import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';
import { ImportCsvStatusResponse } from './type';

export const getImportStatusQueryKey = (importId?: string) => [QUERY_KEYS.getImportStatus, importId];

const getImportStatus = async (importId?: string) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/import/${importId}/status`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetImportStatus = ({
  importId,
  options,
}: {
  importId?: string;
  options?: Record<string, boolean | number>;
}) => {
  return useGenericQuery<ImportCsvStatusResponse, RequestError>(
    getImportStatusQueryKey(importId),
    () => getImportStatus(importId),
    {
      ...options,
    }
  );
};
